import React from 'react';
import Switch from './Switch';
import Alert from '../../Alert';
import Checkboxes from './Checkboxes';
import Select from './Select';
import Repeatable from './Repeatable';
import Form, { ULID, Frequency, Actions, RequiredValidator} from '..';

const Settings = ({settings, filter, unselected}) => {
    return settings.map(setting => {
        if (filter && filter.includes(setting.key) === false) {
            return null;
        }

        switch (setting.kind) {
            case 'Toggle':
                return makeSwitch(setting);

            case 'Checkboxes':
                return makeCheckboxes(setting);

            case 'Select':
                return makeSelect(setting, unselected);

            case 'FrequencyChoices':
                return makeFrequencyChoices(setting);

            default:
                return <Alert theme="danger" title="Unknown field type" message={`Unknown field type ${setting.kind}`} />;
        }
    });
}

const makeSwitch = (setting) => {
    return <Switch key={setting.key}
        name={setting.key}
        label={setting.label}
        help={setting.help}
    />
}

const makeCheckboxes = (setting) => {
    return <Checkboxes key={setting.key}
        name={setting.key}
        label={setting.label}
        help={setting.help}
        options={setting.options.map(option => ({
            label: option,
            value: option,
        }))}
    />
}

const makeSelect = (setting, unselected) => {
    return <Select key={setting.key}
        name={setting.key}
        label={setting.label}
        help={setting.help}
        options={Object.keys(setting.options).map(k => ({
            label: setting.options[k],
            value: k,
        }))}
        unselected={unselected}
    />
}

const makeFrequencyChoices = (setting) => {
    return <Repeatable key={setting.key}
        name={setting.key}
        label={setting.label}
        help={setting.help}
        noItems="No options"
        addItem="Add option"
        sortItems={(a, b) => {
            const getFrequencyValue = (frequency) => {
                if (frequency === 'Once' || frequency === 'Other') {
                    return 0;
                }

                const count = parseInt(frequency.replace(/\D/g, ''));
                const type = frequency.replace(count ?? '', '').trim();
                const weights = {
                    Weeks: 7,
                    Months: 30,
                    Years: 365,
                };
                return (count ?? 1) * (weights[type] ?? 1);
            };

            return getFrequencyValue(a.frequency) - getFrequencyValue(b.frequency);
        }}
        list={(item, i) => item.frequency}
        form={(item, saveItem, cancel) => <FrequencyForm {...{item, saveItem, cancel}} />}
    />
}

const FrequencyForm = ({item, saveItem, cancel}) => {
    return <Form data={item} onSubmit={saveItem}>
        <ULID name="itemId" />
        <Frequency name="frequency" label="New Frequency" validators={[RequiredValidator]} />
        <Actions submit={{label: 'Save'}} cancel={{label: 'Cancel', onClick: cancel}} />
    </Form>
}

export default Settings;
